import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { RenterPaymentMethodInterface } from '@renter-hub/models/Types';
import { getFormattedPaymentMethod } from '@common/constants/PaymentMethod';

interface Props {
  paymentMethodToDelete: RenterPaymentMethodInterface;
}

export const DeletePaymentMethodConfirmation = ({ paymentMethodToDelete }: Props) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Heading
        level={2}
        textStyle="heading-xs"
      >{`Confirm you want to delete ${paymentMethodToDelete.displayName}`}</Heading>
      <Box>
        <Paragraph textStyle="body-bold">Payment method</Paragraph>
        <Paragraph textStyle="body-lg-bold">{paymentMethodToDelete.displayName}</Paragraph>
        <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>{`${getFormattedPaymentMethod(
          paymentMethodToDelete.accountType,
        )}...${paymentMethodToDelete.accountLast4}`}</Paragraph>
      </Box>
    </Box>
  );
};
